import {Object3D} from "three";
import Action from '../classes/Action';
import Engine from '../classes/Engine';
import { CustomEventTypes, TrackerTypes } from '../globals';
import ARTracker from '../classes/ARTracker';
import store from '../state/store';
import SceneObjectUtils from '../classes/utilities/SceneObjectUtils';
import Step from "../classes/scenarioElements/Step";

export default class AddARTrackerAction extends Action
{
	constructor(step?: Step, sceneSelectionObjects?: Object3D[])
	{
		let tracker: ARTracker;
		if (sceneSelectionObjects)
		{
			tracker = new ARTracker(TrackerTypes.MODEL);
			tracker.setModelFromSceneSelection(sceneSelectionObjects);
		}
		else
		{
			const lastSelectedTrackerType = store.getState().workspaceModule.lastSelectedTrackerType;
			tracker = new ARTracker(lastSelectedTrackerType ? lastSelectedTrackerType : TrackerTypes.MODEL);
		}

		const actionName = "Added " + tracker.name;
		const previousSelection = Engine.getInstance().getPickingManager().getCurrentSelection();

		super([tracker, step], [tracker, previousSelection, step], actionName, [step]);
	}

	do(tracker: ARTracker, step: Step)
	{
		if (step.trackers)
		{
			step.trackers.push(tracker.userData.guid);
		}
		Engine.getInstance().addObject(tracker, ARTracker.trackersRoot);
		Engine.getInstance().getPickingManager().clearSelection(false);
		Engine.getInstance().getPickingManager().selectObject(tracker);
		Engine.getInstance().getPickingManager().storeSelection();

		document.dispatchEvent(new CustomEvent(CustomEventTypes.onTrackerListUpdated));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.objectSelectionChanged));
	}

	undo(tracker: ARTracker, previousSelection: any, step: Step)
	{
		if (step.trackers)
		{
			step.trackers = step.trackers.filter((t: string) => t !== tracker.userData.guid);
		}
		Engine.getInstance().getPickingManager().restoreSelection(previousSelection);
		Engine.getInstance().removeObject(tracker, true);
		document.dispatchEvent(new CustomEvent(CustomEventTypes.onTrackerListUpdated));
		document.dispatchEvent(new CustomEvent(CustomEventTypes.objectSelectionChanged));
	}

	verify(step?: Step): boolean 
	{
		return !!step;
	}

	dispose()
	{
		if ( this.doParams )
		{
			const tracker = this.doParams[0];
			SceneObjectUtils.disposeObject(tracker);
		}
	}
}
